import { useParams } from 'react-router-dom';

import TeamsWorkspace from '../../features/teams/layouts/workspace';

export default function TeamsPage() {
    const { teamId } = useParams();
    const id = Number(teamId);
    return <TeamsWorkspace teamId={teamId ? (Number.isInteger(id) && id > 0 ? id : 0) : null} />;
}
